module.exports = __webpack_public_path__ + "static/media/household_door_wooden_internal_shut_020.7e72a4a9.wav";